module.exports = __webpack_public_path__ + "img/ch61.ec441fe1.png";